export default __webpack_public_path__ + "static/media/Oussama.1f912eaf.png";